import { useState } from 'react'

import { Button } from '@material-ui/core'

import api from 'common/api'

import RegisterModal from './RegisterModal'

type RequestActionProps = {
  show: boolean
  onClose: () => void
  eventId: string
  highSchoolName: string
  onEventChange: () => void
  allowRepMeeting?: boolean
  placeName?: string
  meetingLink?: string
  allowRepLocationType: boolean
}
const RequestAction = ({
  show,
  onClose,
  eventId,
  highSchoolName,
  onEventChange,
  allowRepMeeting,
  placeName,
  meetingLink,
  allowRepLocationType,
}: RequestActionProps) => {
  const [isConfirming, setIsConfirming] = useState(false)
  const [hasRegisterError, setHasRegisterError] = useState(false)
  const request = (newPlaceName?: string, isVirtual?: boolean) => {
    setIsConfirming(true)
    const requestBody = {
      ...(placeName !== newPlaceName && { Location: { PlaceName: newPlaceName } }),
      ...(allowRepLocationType && { Virtual: isVirtual || false }),
    }
    api
      .post(`/api/highschools/visits/${eventId}/register`, requestBody)
      .then(() => {
        onEventChange()
        onClose()
        setIsConfirming(false)
        setHasRegisterError(false)
      })
      .catch(() => {
        setHasRegisterError(true)
        setIsConfirming(false)
      })
  }
  return (
    <RegisterModal
      show={show}
      title="Confirm Request"
      onConfirm={request}
      onClose={onClose}
      allowRepMeeting={allowRepMeeting}
      placeName={placeName}
      meetingLink={meetingLink}
      isConfirming={isConfirming}
      hasRegisterError={hasRegisterError}
      allowRepLocationType={allowRepLocationType}
    >
      <div className="shared-information-label">
        <strong>{highSchoolName}</strong> requires approval for all visit requests. You will be notified of the outcome
        of your request.
      </div>
    </RegisterModal>
  )
}

const Trigger = ({ onOpen }: { onOpen: () => void }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      size="small"
      onClick={() => onOpen()}
    >
      Send Registration Request
    </Button>
  )
}

RequestAction.Trigger = Trigger
export default RequestAction
